/**
 * <s-countdown> — live countdown to a fixed moment.
 *
 * Required markup:
 *   data-target — ISO 8601 instant to count down to.
 *   [data-countdown-days], [data-countdown-hours], [data-countdown-minutes], [data-countdown-seconds] — value outlets.
 * Optional: [data-countdown-live] is hidden once the target passes.
 */
class SCountdown extends HTMLElement {
  #timer;

  connectedCallback() {
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #tick() {
    const target = Date.parse(this.dataset.target || '');
    if (Number.isNaN(target)) return;
    const remaining = Math.max(0, target - Date.now());
    if (remaining === 0) {
      clearInterval(this.#timer);
      this.querySelector('[data-countdown-live]')?.setAttribute('hidden', '');
    }
    const total = Math.floor(remaining / 1000);
    this.#set('days', Math.floor(total / 86400));
    this.#set('hours', Math.floor((total % 86400) / 3600));
    this.#set('minutes', Math.floor((total % 3600) / 60));
    this.#set('seconds', total % 60);
  }

  #set(unit, value) {
    const el = this.querySelector(`[data-countdown-${unit}]`);
    if (el) el.textContent = String(value).padStart(2, '0');
  }
}

if (!customElements.get('s-countdown')) {
  customElements.define('s-countdown', SCountdown);
}
